__turbopack_context__.v({
  "body": "frExZq_body",
  "closeButton": "frExZq_closeButton",
  "error": "frExZq_error",
  "footer": "frExZq_footer",
  "head": "frExZq_head",
  "lede": "frExZq_lede",
  "modal": "frExZq_modal",
  "title": "frExZq_title",
});
